/* eslint-disable */

<template>
  <div>
    <div class="vx-row">
      <div class="vx-col lg:w-3/12 md:w-3/12 sm:w-5/5">
        <vx-card class="mb-base">
          <h3 class="font-bold mb-4">Step Completion</h3>
          <div :class="completion.step1 ? 'text-success' : ''" class="vx-row mb-4">
            <div class="vx-col w-1/5 p-3 align-middle flex">
              <feather-icon v-if="completion.step1" :icon="'CheckCircleIcon'"
                            class="p-4 inline-flex rounded-full"></feather-icon>
              <feather-icon v-else :icon="'XCircleIcon'" class="p-4 inline-flex rounded-full"></feather-icon>
            </div>
            <div class="vx-col w-4/5 p-3">
              <p class="text-xl font-bold my-1 ubuntu-font">Step 1</p>
              <p class="text-xl font-bold my-1 ubuntu-font">Resolve Connectivity Issues</p>
            </div>
          </div>
          <div :class="completion.step2 ? 'text-success' : ''" class="vx-row mb-4">
            <div class="vx-col w-1/5 p-3 align-middle flex">
              <feather-icon v-if="completion.step2" :icon="'CheckCircleIcon'"
                            class="p-4 inline-flex rounded-full"></feather-icon>
              <feather-icon v-else :icon="'XCircleIcon'" class="p-4 inline-flex rounded-full"></feather-icon>
            </div>
            <div class="vx-col w-4/5 p-3">
              <p class="text-xl font-bold my-1 ubuntu-font">Step 2</p>
              <p class="text-xl font-bold my-1 ubuntu-font">Verify a Successful Connection</p>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-col lg:w-9/12 md:w-9/12 sm:w-5/5">
        <vx-card class="mb-base">
          <div class="p-5">
            <div style="height: 35rem">
              <vue-command id="command_prompt"
                           :commands="commands"
                           :prompt="'C:\\Users\\'+activeUserInfo.first_name.toLowerCase().replace(/ /g,'')+'>'"
                           class="rounded border-white border-solid"
                           style="background-color: #111111" title="Command Prompt"/>

            </div>

          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>

import Prism from 'vue-prism-component'
import VueCommand, {createStdout, createStderr} from 'vue-command'
import 'vue-command/dist/vue-command.css'

export default {
  data () {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),

      completion: {
        step1: false,
        step2: false
      },

      commands: {
        'mema': () => createStdout('Is the best developer in the world'),
        'help': () => createStdout('Available commands:<br>ping *computer* &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Ping Another Computer<br>ipconfig *argument* &nbsp;&nbsp;&nbsp;&nbsp; Windows IP Configuration'),
        'ipconfig': () => undefined,
        'ping': () => undefined


      }
    }
  },
  methods: {},
  components: {
    Prism,
    VueCommand
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  mounted () {
    //Disable Mark Button and Update Options in Renderer
    this.dataLocal.options.show_mark_button = false
    this.$emit('simulation_update_options', this.dataLocal)

    this.commands.ipconfig = (x) => {


      if (x._[1] !== '/flushdns') {
        return createStderr('<span class="text-danger">% Invalid arguments</span>')
      }

      this.completion.step1 = true
      return createStdout('<span class="text-success">Windows IP Configuration<br>Successfully flushed the DNS Resolver Cache.</span>')

    }
    this.commands.ping = (x) => {

      if (this.completion.step1 !== true) {
        return createStderr('<span class="text-danger">% You must resolve connectivity issues first</span>')
      }

      if (x._[1] !== 'ComputerA') {
        return createStderr('<span class="text-danger">% Invalid Computer</span>')
      }

      this.completion.step2 = true

      setTimeout(() => {
        this.$emit('simulation_full_correct', 1)
      }, 1250)

      return createStdout('' +
        'Pinging 10.10.10.20 [ComputerA] with 32 bytes of data:<br>' +
        'Reply from 10.10.10.20: bytes=32 time=13ms TTL=52<br' +
        '>Reply from 10.10.10.20: bytes=32 time=13ms TTL=52<br' +
        '>Reply from 10.10.10.20: bytes=32 time=13ms TTL=52<br>' +
        'Reply from 10.10.10.20: bytes=32 time=13ms TTL=52<br><br>' +
        'Ping statistics for 10.10.10.20:<br>' +
        '‎ Packets: Sent = 4, Received = 4, Lost = 0 (0% loss),<br>' +
        'Approximate round trip times in milli-seconds:<br>' +
        '‎ Minimum = 13ms, Maximum = 13ms, Average = 13ms<br><br>' +
        '<span class="text-success font-bold">Simulation Completed Successfully</span>')


    }
  }
}
</script>

